import React, { useEffect } from "react";

import { useSelector } from "react-redux";

import IBIntergration from "components/IBIntergration/IBIntergration";
import { selectAutomationAllowed } from "store/slices/main";
import LeaderboardsTable from "components/Leaderboards/LeaderboardsTable";
import PerformanceStats from "./PerformanceStats";
import "./Home.scss";

const Home = () => {
  const automationAllowed = useSelector(selectAutomationAllowed);
  useEffect(() => {
    document.title = "Home | Dindicator Dashboard";
  }, []);

  return (
    <>
      <PerformanceStats />

      <LeaderboardsTable />

      {automationAllowed && <IBIntergration />}
    </>
  );
};

export default Home;
